import type { StorePrinter } from "../types/printer.types";

export const DIRECT_PRINTER_TEST_MAX_AGE_MS = 30 * 24 * 60 * 60 * 1_000;

/**
 * Return an operator-facing readiness problem, or null when dispatch may start.
 *
 * SYSTEM profiles render into the operating-system print dialog. The operator
 * chooses and confirms the physical device there, so stale device-test evidence
 * must not prevent invoice preview. Direct transports have no such checkpoint
 * and therefore retain the recent-test requirement.
 */
export function printerReadinessError(
  printer: StorePrinter,
  nowMs = Date.now(),
): string | null {
  if (!printer.isActive) return `Printer "${printer.name}" is disabled`;
  if (printer.connectionType === "SYSTEM") return null;

  const testedAt = printer.lastTestedAt
    ? new Date(printer.lastTestedAt).getTime()
    : Number.NaN;
  if (
    printer.lastTestStatus !== "SUCCEEDED" ||
    !Number.isFinite(testedAt) ||
    nowMs - testedAt > DIRECT_PRINTER_TEST_MAX_AGE_MS
  ) {
    return `Printer "${printer.name}" needs a successful test from the last 30 days. Open Printer Settings and run Test.`;
  }
  return null;
}
